import React from "react";

import {
  motion,
} from "framer-motion";

import {
  Link,
} from "react-router-dom";

import {
  navItems,
} from "../../constants";

import {
  useStateContext,
} from "../../context/ContextProvider";

import ToggleDark from "../utils/ToggleDark";
import ToggleLanguages from "../utils/ToggleLanguages";

import {
  FiArrowLeft,
  FiArrowRight,
} from "react-icons/fi";
import { MobileMealsViewToggle } from "../utils";


function Navmobile({
  active,
  setOpenNavigation,
}) {
  const {
    currentDir,
  } = useStateContext();

  const isRTL =
    currentDir === "rtl";

  const DirectionArrow =
    isRTL
      ? FiArrowLeft
      : FiArrowRight;


  return (
    <>

      {/* =========================
          OVERLAY
      ========================== */}

      <motion.div
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
        }}
        exit={{
          opacity: 0,
        }}
        transition={{
          duration: 0.3,
        }}
        onClick={() =>
          setOpenNavigation(false)
        }
        className="
          fixed
          inset-0

          z-[997]

          bg-color-2/55

          backdrop-blur-[3px]

          lg:hidden
        "
      />


      {/* =========================
          DRAWER
      ========================== */}

      <motion.aside
        initial={{
          x: isRTL
            ? "105%"
            : "-105%",
        }}
        animate={{
          x: 0,
        }}
        exit={{
          x: isRTL
            ? "105%"
            : "-105%",
        }}
        transition={{
          type: "spring",
          stiffness: 260,
          damping: 28,
        }}
        className={`
          fixed

          top-0
          bottom-0

          z-[998]

          w-[88%]
          max-w-[390px]

          bg-back-primery
          dark:bg-back-darksecondary

          shadow-[0_0_60px_rgba(0,0,0,0.25)]

          lg:hidden

          ${
            isRTL
              ? "right-0"
              : "left-0"
          }
        `}
      >

        {/* Accent */}

        <div
          className="
            absolute
            top-0
            start-0

            w-full
            h-[3px]

            bg-gradient-to-r

            from-color-1
            via-color-1
            to-transparent
          "
        />


        {/* Decorative circle */}

        <div
          className="
            absolute
            -top-24
            -end-24

            w-60
            h-60

            rounded-full

            bg-color-1/10

            blur-[80px]

            pointer-events-none
          "
        />


        <div
          className="
            relative

            h-full

            flex
            flex-col

            pt-28
            pb-6

            px-5
          "
        >

          {/* =========================
              NAV ITEMS
          ========================== */}

          <nav
            className="
              flex
              flex-col

              gap-2
            "
          >
            {navItems.map(
              (item, index) => {

                const isActive =
                  active ===
                  index + 1;

                return (
                  <Link
                    key={
                      item.id ||
                      index
                    }
                    to={item.link}
                    onClick={() => {
                      window.scrollTo({
                        top: 0,
                        behavior:
                          "smooth",
                      });

                      setOpenNavigation(
                        false
                      );
                    }}
                  >
                    <motion.div
                      initial={{
                        opacity: 0,
                        x: isRTL
                          ? 25
                          : -25,
                      }}
                      animate={{
                        opacity: 1,
                        x: 0,
                      }}
                      transition={{
                        delay:
                          index * 0.05,
                      }}
                      whileTap={{
                        scale: 0.98,
                      }}
                      className={`
                        group

                        relative

                        flex
                        items-center
                        justify-between

                        overflow-hidden

                        rounded-[1.25rem]

                        px-4
                        py-4

                        transition-all
                        duration-300

                        ${
                          isActive
                            ? `
                              bg-color-2
                              text-white
                              shadow-[0_10px_30px_rgba(68,37,20,0.18)]
                            `
                            : `
                              text-tcolor-4
                              dark:text-white/80

                              hover:bg-color-1/10
                            `
                        }
                      `}
                    >

                      {/* Start */}

                      <div
                        className="
                          flex
                          items-center

                          gap-4
                        "
                      >
                        {/* Icon */}

                        <div
                          className={`
                            flex

                            w-10
                            h-10

                            shrink-0

                            items-center
                            justify-center

                            rounded-xl

                            text-lg

                            transition-all
                            duration-300

                            ${
                              isActive
                                ? `
                                  bg-color-1
                                  text-white
                                `
                                : `
                                  bg-color-1/10
                                  text-color-1
                                `
                            }
                          `}
                        >
                          {item.icon}
                        </div>


                        {/* Text */}

                        <span
                          className="
                            font-kufi
                            text-sm
                            md:text-base
                          "
                        >
                          {currentDir ===
                          "ltr"
                            ? item.titleEn
                            : item.titleAr}
                        </span>

                      </div>


                      {/* Arrow */}

                      <div
                        className={`
                          flex

                          w-8
                          h-8

                          items-center
                          justify-center

                          rounded-full

                          transition-all
                          duration-300

                          ${
                            isActive
                              ? `
                                bg-white/10
                                text-color-1
                              `
                              : `
                                text-n-5
                                dark:text-white/40

                                group-hover:text-color-1
                              `
                          }
                        `}
                      >
                        <DirectionArrow
                          size={15}
                        />
                      </div>


                      {/* Active line */}

                      {isActive && (
                        <div
                          className="
                            absolute
                            start-0
                            top-1/2
                            -translate-y-1/2

                            w-[3px]
                            h-8

                            rounded-e-full

                            bg-color-1
                          "
                        />
                      )}

                    </motion.div>
                  </Link>
                );
              }
            )}
          </nav>


          {/* =========================
              BOTTOM CONTROLS
          ========================== */}

          <div
            className="
              mt-auto

              pt-6

              border-t
              border-color-2/10
              dark:border-white/10
            "
          >

            <div
              className="
                flex
                items-center
                justify-center

                gap-3
              "
            >
    <div
                className="
                  flex

                  items-center
                  justify-center

                  rounded-xl

                  border
                  border-color-2/10
                  dark:border-white/10

                  bg-color-2/5
                  dark:bg-white/5

                  p-2
                "
              >
                   <MobileMealsViewToggle />
              </div>
              <div
                className="
                  flex

                  items-center
                  justify-center

                  rounded-xl

                  border
                  border-color-2/10
                  dark:border-white/10

                  bg-color-2/5
                  dark:bg-white/5

                  p-2
                "
              >
               
                <ToggleLanguages />
              </div>


              <div
                className="
                  flex

                  items-center
                  justify-center

                  rounded-xl

                  border
                  border-color-2/10
                  dark:border-white/10

                  bg-color-2/5
                  dark:bg-white/5

                  p-2
                "
              >
                <ToggleDark />
              </div>

            </div>

          </div>

        </div>

      </motion.aside>

    </>
  );
}

export default Navmobile;